export class SummaryMetricsByDay {
    type:                               string;
    callVolumeTotal:                    number;
    billableMinutesTotal:               number;
    minutesSavedTotal:                  number;
    appointmentsTotal:                  number;
    appointmentMinutesTotal:            number;
    generalInquiriesTotal:              number;
    generalInquiryMinutesTotal:         number;
    wrongNumbersTotal:                  number;
    wrongNumberMinutesTotal:            number;
    unableToSchedulesTotal: number;
    unableToScheduleMinutesTotal: number;
    miscellaneousTotal:                 number;
    miscellaneousMinutesTotal:          number;
    hotLeadsTotal: number;
    hotLeadMinutesTotal: number;
    appointmentFollowupsTotal: number;
    appointmentFollowupMinutesTotal: number;
    followupsTotal:                     number;
    followupMinutesTotal:               number;
    avgCallTime: number;
    transferToRetailers: number;
    transferToRetailerMinutes: number;
    withoutRetailerInvolvement:         number;
    previousCallVolumeTotal:            number;
    previousBillableMinutesTotal:       number;
    previousMinutesSavedTotal:          number;
    previousAppointmentsTotal:          number;
    previousAppointmentMinutesTotal:    number;
    previousGeneralInquiriesTotal:      number;
    previousGeneralInquiryMinutesTotal: number;
    previousWrongNumbersTotal:          number;
    previousWrongNumberMinutesTotal:    number;
    previousMiscellaneousTotal:         number;
    previousMiscellaneousMinutesTotal:  number;
    previousFollowupsTotal:             number;
    previousFollowupMinutesTotal:       number;
    previousHotLeadsTotal: number;
    previousHotLeadMinutesTotal: number;
    previousAppointmentFollowupsTotal: number;
    previousAppointmentFollowupMinutesTotal: number;
    previousAvgCallTime: number;
    previousTransferToRetailers: number;
    previousTransferToRetailerMinutes: number;
    previousWithoutRetailerInvolvement: number;
    pageLength:                         number;
    pageNumber:                         number;
    totalRecords:                       number;
    statusUpdateRequests: number;
    records:                            SummaryMetricByDayRecord[];
}

export interface SummaryMetricByDayRecord {
    date:                  string;
    callVolume:            number;
    billableMinutes:       number;
    minutesSaved:          number;
    appointments:          number;
    appointmentMinutes:    number;
    generalInquiries:      number;
    generalInquiryMinutes: number;
    wrongNumbers:          number;
    wrongNumberMinutes:    number;
    miscellaneous:         number;
    miscellaneousMinutes:  number;
    followups:             number;
    followupMinutes:       number;
    unableToSchedules:     number;
    unableToScheduleMinutes: number;
    hotLeads: number;
    hotLeadMinutes: number;
    appointmentFollowups: number;
    appointmentFollowupMinutes: number;
    transferToRetailers: number;
    transferToRetailerMinutes: number;
    WithoutRetailerInvolvement: number;
    statusUpdateRequests: number;
}

export const EmptySummaryMetricsByDay: SummaryMetricsByDay = {
    type: '',
    callVolumeTotal: 0,
    billableMinutesTotal: 0,
    minutesSavedTotal: 0,
    appointmentsTotal: 0,
    appointmentMinutesTotal: 0,
    generalInquiriesTotal: 0,
    generalInquiryMinutesTotal: 0,
    wrongNumbersTotal: 0,
    wrongNumberMinutesTotal: 0,
    miscellaneousTotal: 0,
    miscellaneousMinutesTotal: 0,
    followupsTotal: 0,
    followupMinutesTotal: 0,
    unableToSchedulesTotal: 0,
    unableToScheduleMinutesTotal: 0,
    hotLeadsTotal: 0,
    hotLeadMinutesTotal: 0,
    appointmentFollowupsTotal: 0,
    appointmentFollowupMinutesTotal: 0,
    avgCallTime: 0,
    transferToRetailers: 0,
    transferToRetailerMinutes: 0,
    withoutRetailerInvolvement: 0,
    previousCallVolumeTotal: 0,
    previousBillableMinutesTotal: 0,
    previousMinutesSavedTotal: 0,
    previousAppointmentsTotal: 0,
    previousAppointmentMinutesTotal: 0,
    previousGeneralInquiriesTotal: 0,
    previousGeneralInquiryMinutesTotal: 0,
    previousWrongNumbersTotal: 0,
    previousWrongNumberMinutesTotal: 0,
    previousMiscellaneousTotal: 0,
    previousMiscellaneousMinutesTotal: 0,
    previousFollowupsTotal: 0,
    previousFollowupMinutesTotal: 0,
    previousHotLeadsTotal: 0,
    previousHotLeadMinutesTotal: 0,
    previousAppointmentFollowupsTotal: 0,
    previousAppointmentFollowupMinutesTotal: 0,
    previousAvgCallTime: 0,
    previousTransferToRetailers: 0,
    previousTransferToRetailerMinutes: 0,
    previousWithoutRetailerInvolvement: 0,
    pageLength: 0,
    pageNumber: 0,
    totalRecords: 0,
    statusUpdateRequests: 0,
    records: []
  };
